import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import Global from '../store/global-selectors';

/**
 *
 * @param {string} fulfillmentProviderId
 * @returns {Array<object>}
 */
export const useActiveSellerFulfillmentProviders = (fulfillmentProviderId) => {
  // oxlint-disable-next-line @typescript-eslint/no-unnecessary-condition
  const sellerFulfillmentProviders = useSelector(Global.selectSellerActiveFulfillmentProviders) || [];
  return useMemo(() => {
    return sellerFulfillmentProviders.filter((sellerFulfillmentProvider) => {
      return !fulfillmentProviderId || sellerFulfillmentProvider.fulfillmentProviderId === fulfillmentProviderId;
    });
    // oxlint-disable-next-line react-hooks/exhaustive-deps -- sellerFulfillmentProviders changes every render
  }, [sellerFulfillmentProviders, fulfillmentProviderId]);
};

/**
 *
 * @param {string} fulfillmentProviderId
 * @returns {Array<object>}
 */
export const useAllSellerFulfillmentProviders = (fulfillmentProviderId) => {
  // oxlint-disable-next-line @typescript-eslint/no-unnecessary-condition
  const sellerFulfillmentProviders = useSelector(Global.selectSellerAllFulfillmentProviders) || [];
  return useMemo(() => {
    return sellerFulfillmentProviders.filter((sellerFulfillmentProvider) => {
      return !fulfillmentProviderId || sellerFulfillmentProvider.fulfillmentProviderId === fulfillmentProviderId;
    });
    // oxlint-disable-next-line react-hooks/exhaustive-deps -- sellerFulfillmentProviders changes every render
  }, [sellerFulfillmentProviders, fulfillmentProviderId]);
};
